/* Progressive enhancement: all destination highlights remain visible without JS. */
if (!customElements.get('buti-destination-list')) {
  customElements.define('buti-destination-list', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-collapse-mobile')) return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.items = [...this.querySelectorAll('.bc-destination__item')];
      this.limit = Number(this.dataset.visibleCount) || 3;
      this.expanded = false;
      this.mobile = window.matchMedia('(max-width: 699px)');
      this.update = () => {
        const folded = this.mobile.matches && !this.expanded;
        this.items.forEach((item, index) => { item.hidden = folded && index >= this.limit; });
        this.button.hidden = !this.mobile.matches;
        this.button.setAttribute('aria-expanded', String(this.mobile.matches && this.expanded));
        this.button.firstElementChild.textContent = this.expanded ? this.button.dataset.less : this.button.dataset.more;
        this.button.lastElementChild.textContent = this.expanded ? '−' : '+';
      };
      this.toggle = () => {
        this.expanded = !this.expanded;
        this.update();
        if (!this.expanded) this.button.scrollIntoView({ block: 'nearest' });
      };
      this.button.addEventListener('click', this.toggle);
      this.mobile.addEventListener('change', this.update);
      this.update();
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
      this.mobile?.removeEventListener('change', this.update);
    }
  });
}
